import { useContext } from "react";
import { Formik, Form, FastField } from "formik";
import { TextField } from "formik-material-ui";
import TextFieldMUI from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Loader from "../../themes/components/Loader";

import useStyles from "./Styles";
import useButtonStyles from "../../styles/Buttons";
import useSharedStyles from "../../styles/Shared";
import { AccountContext } from "../../contexts/CurrentUser";
import { Box, InputLabel } from "@mui/material";

type Props = {
  onSubmit: (values: UserUpdateVars, formikBag: unknown) => void | Promise<unknown>;
};

const Profile: React.FC<Props> = ({ onSubmit }) => {
  const { account } = useContext(AccountContext);

  const { classes } = useStyles();
  const { classes: sharedClasses } = useSharedStyles();
  const { classes: buttonClasses, cx } = useButtonStyles();

  if (account === null) {
    return <Loader />;
  }

  return (
    <Box className={sharedClasses.borderedBox} sx={{ bgcolor: "#fff" }}>
      <Typography variant="h3">General Information</Typography>
      <Formik<UserUpdateVars>
        initialValues={{
          input: {
            first_name: account ? account.first_name : "",
            last_name: account ? account.last_name : "",
          },
        }}
        onSubmit={onSubmit}
      >
        {() => (
          <Form>
            <div>
              <Box display={"flex"} gap={2} width="100%" justifyContent={"space-between"}>
                <Box className={sharedClasses.fieldBox} flex={1}>
                  <InputLabel>First Name</InputLabel>
                  <FastField
                    component={TextField}
                    name="input.first_name"
                    placeholder="First Name"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Box>
                <Box className={sharedClasses.fieldBox} flex={1}>
                  <InputLabel>Last Name</InputLabel>
                  <FastField
                    component={TextField}
                    name="input.last_name"
                    placeholder="Last Name"
                    fullWidth
                    variant="outlined"
                    type="text"
                  />
                </Box>
              </Box>
              <div className={sharedClasses.fieldBox}>
                <InputLabel>Account Email</InputLabel>
                <TextFieldMUI
                  placeholder="Account Email"
                  fullWidth
                  variant="outlined"
                  type="text"
                  disabled
                  value={account ? account.email : ""}
                />
              </div>
            </div>

            <Button
              sx={{ mb: 2 }}
              type="submit"
              className={cx(buttonClasses.blue, buttonClasses.iconButton)}
            >
              Save
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default Profile;
